export default __webpack_public_path__ + "static/media/bkg--masterplan.7d83fa2b.jpg";